"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrganizationMemberInvitationsModule = void 0;
const common_1 = require("../../../common");
class OrganizationMemberInvitationsModule extends common_1.APIModule {
    constructor(client) {
        super(client, '/organization-member-invitations');
    }
    inviteUser(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint(['invite']);
            const response = yield this.client.post(endpoint, payload);
            return response.data;
        });
    }
    /**
     * What an invitation link can say to someone who is not signed in.
     *
     * Anonymous by design — see the DTO. The invitation id is the credential.
     */
    getInvitationSummary(organizationMemberInvitationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([
                organizationMemberInvitationId,
                'summary',
            ]);
            const response = yield this.client.get(endpoint);
            return response.data;
        });
    }
    updateInvitation(organizationMemberInvitationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([organizationMemberInvitationId]);
            const response = yield this.client.put(endpoint, payload);
            return response.data;
        });
    }
    deleteInvitation(organizationMemberInvitationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([organizationMemberInvitationId]);
            const response = yield this.client.delete(endpoint);
            return response.data;
        });
    }
    acceptInvitation(organizationMemberInvitationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([
                organizationMemberInvitationId,
                'accept',
            ]);
            const response = yield this.client.post(endpoint, payload);
            return response.data;
        });
    }
    declineInvitation(organizationMemberInvitationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([
                organizationMemberInvitationId,
                'decline',
            ]);
            const response = yield this.client.post(endpoint, payload);
            return response.data;
        });
    }
}
exports.OrganizationMemberInvitationsModule = OrganizationMemberInvitationsModule;
